import { createElement } from 'rax';
import dayjs from 'dayjs';
import DatePicker from '../date-picker';
import { FieldElement } from '../field';
export default class DatePickerField extends FieldElement {
    renderPreview(value) {
        const { dateFormat = 'YYYY-MM-DD' } = this.props;
        return dayjs(value).format(dateFormat);
    }
    renderControl() {
        const { dateFormat } = this.props;
        return <DatePicker format={dateFormat} {...this.getProps()}/>;
    }
}
DatePickerField.displayName = 'DatePickerField';
